import React, { useEffect, useState } from "react";

import * as participanteService from "../../services/participante.service";
import { IParticipante } from "../../common/interfaces/participante.interface";

import { Col } from "react-bootstrap";
import { Row } from "reactstrap";

const Home: React.FC = () => {

  const [participante, setParticipante] = useState<IParticipante>();
  const [loading, setLoading] = useState<boolean>(true);


  useEffect(() => {
    (async () => {
      try {
        const response = await participanteService.obterParticipante();

        setParticipante(response);
        setLoading(false);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  return (
    <>
      <div className="content py-3">
        <div className="container-xl mb-3">
          <div className="page-header">
            <div className="row">
              <h1>Home</h1>
            </div>
          </div>
          <div className="row row-deck row-cards">
            <div className="col-sm-12 col-lg-12">
              <div className="card">

                <div className="card-body">
                  <div className={'dimmer' + (loading ? ' active' : '')}>
                    <div className="loader"></div>
                    <div className={"dimmer-content" + (loading ? ' medium-box-loader' : '')} >
                      <div className="subheader mb-3">Dados Cadastrais</div>
                      <Row>
                        <Col xl={8} lg={7} md={8}>
                          <div className="mb-3">
                            <label className="form-label mb-0">Razão Social</label>
                            <div className="form-control-plaintext pt-1">{participante?.razaoSocial}</div>
                          </div>
                        </Col>
                        <Col xl={4} lg={5} md={4}>
                          <div className="mb-3">
                            <label className="form-label mb-0">CNPJ</label>
                            <div className="form-control-plaintext pt-1">{participante?.cnpj}</div>
                          </div>
                        </Col>
                        <Col xl={8} lg={7} md={12}>
                          <div className="mb-3">
                            <label className="form-label mb-0">Endereço</label>
                            <div className="form-control-plaintext pt-1">{participante?.endereco}</div>
                          </div>
                        </Col>
                        <Col xl={4} lg={5} md={12}>
                          <div className="mb-3">
                            <label className="form-label mb-0">Bairro</label>
                            <div className="form-control-plaintext pt-1">{participante?.bairro}</div>
                          </div>
                        </Col>
                        <Col xl={8} lg={7} md={8}>
                          <div className="mb-3">
                            <label className="form-label mb-0">Cidade</label>
                            <div className="form-control-plaintext pt-1">{participante?.cidade}</div>
                          </div>
                        </Col>
                        <Col xl={4} lg={5} md={4}>
                          <div className="mb-3">
                            <label className="form-label mb-0">Estado</label>
                            <div className="form-control-plaintext pt-1">{participante?.estado}</div>
                          </div>
                        </Col>
                      </Row>
                      <div>
                        <div className="subheader mb-3 mt-3">Contatos</div>
                        {participante?.contatos.map(c => (
                          <Row>
                            <Col xl={3} lg={3} md={3} sm={3} xs={12} className="mb-3">
                                <label className="form-label mb-0">Nome</label>
                                <div className="form-control-plaintext pt-1">{c?.nome}</div>
                            </Col>
                            <Col xl={6} lg={6} md={6} sm={6} xs={12} className="mb-3">                              
                              <label className="form-label mb-0">E-mail</label>
                              <div className="form-control-plaintext pt-1">{c?.email}</div>
                            </Col>
                            <Col xl={3} lg={3} md={3} sm={3} xs={12} className="mb-3">
                              <label className="form-label mb-0">Telefone</label>
                              <div className="form-control-plaintext pt-1">{c?.telefone ? c?.telefone : "-"}</div>
                            </Col>
                          </Row>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
